export default "__VITE_ASSET__BRzLKSAk__"